import { parse } from 'date-fns';

/**
 * Converts a string in the american format "MM/DD/YYYY" to a javascript Date
 * @param dateString
 * @returns parsed date
 */
export function americanDateStringToDate(dateString: string): Date {
  return parse(dateString, 'M/d/y', new Date());
}

/**
 * Parses a UTC date/time from the API.
 * This is necessary because .NET often serializes UTC without the correct Z suffix.
 */
export function parseUtcDateTimeString(
  value: string | Date | null | undefined
): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    const parsed = new Date(trimmed);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  const iso = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
  const parsed = new Date(`${iso}Z`);
  return isNaN(parsed.getTime()) ? null : parsed;
}
